import React from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';

export default function Layout() {
  return (
    <div className='w-full flex flex-col z-90'>
      <Navigation />
      <Outlet /> {/* This will render the child components */}
      <Footer />
    </div>
  );
}
